"use strict";

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.symbol.description.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.symbol.iterator.js");

require("core-js/modules/es.array.iterator.js");

require("core-js/modules/es.string.iterator.js");

require("core-js/modules/web.dom-collections.iterator.js");

require("core-js/modules/es.object.define-property.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseFeatureInfoTextXml = exports.parseFeatureInfoJSON = exports.parseFeatureInfo = exports.parseEsriWmsRawXml = exports.parseEsriWmsFeatureInfoXml = void 0;

require("core-js/modules/es.array.join.js");

require("core-js/modules/es.array.concat.js");

var _GeoJSON = _interopRequireDefault(require("ol/format/GeoJSON"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

var prettifyXml = function prettifyXml(source) {
  var xmlDoc = source;

  if (typeof source === 'string') {
    xmlDoc = new DOMParser().parseFromString(source, 'application/xml');
  }

  var xsltDoc = new DOMParser().parseFromString([// describes how we want to modify the XML - indent everything
  '<xsl:stylesheet xmlns:xsl="http://www.w3.org/1999/XSL/Transform">', '  <xsl:strip-space elements="*"/>', '  <xsl:template match="para[content-style][not(text())]">', // change to just text() to strip space in text nodes
  '    <xsl:value-of select="normalize-space(.)"/>', '  </xsl:template>', '  <xsl:template match="node()|@*">', '    <xsl:copy><xsl:apply-templates select="node()|@*"/></xsl:copy>', '  </xsl:template>', '  <xsl:output indent="yes"/>', '</xsl:stylesheet>'].join('\n'), 'application/xml');
  var xsltProcessor = new XSLTProcessor();
  xsltProcessor.importStylesheet(xsltDoc);
  var resultDoc = xsltProcessor.transformToDocument(xmlDoc);
  var resultXml = new XMLSerializer().serializeToString(resultDoc);
  return resultXml;
};
/**
 * Method to parse the features from GetFeatureInfo response having the 
 * info_format = 'application/json'
 */


var parseFeatureInfoJSON = function parseFeatureInfoJSON(source) {
  var features = new _GeoJSON.default().readFeatures(source);
  /*
     console.log('newFeatures', features);
     features.forEach((feature) => {
         console.log('feature', feature);
     });
  */

  return features;
};
/**
 * Method to parse the features from GetFeatureInfo response having the 
 * info_format = 'text/xml'
 */


exports.parseFeatureInfoJSON = parseFeatureInfoJSON;

var parseFeatureInfoTextXml = function parseFeatureInfoTextXml(source) {
  var xmlStr = prettifyXml(source);
  var feature = {};
  var properties = {};
  properties['text/xml'] = xmlStr;

  feature['getProperties'] = function () {
    return properties;
  };

  feature['getId'] = function () {
    return "text/xml.".concat(Date.now());
  };

  return [feature];
};
/**
 * Method to parse the features from GetFeatureInfo response having the 
 * info_format = 'application/vnd.esri.wms_raw_xml'
'
 */


exports.parseFeatureInfoTextXml = parseFeatureInfoTextXml;

var parseEsriWmsRawXml = function parseEsriWmsRawXml(source) {
  var doc = null;

  if (typeof source === 'string') {
    var parser = new DOMParser();
    doc = parser.parseFromString(source, "application/xml");
  } else {
    doc = source;
  }

  var features = [];
  var featureInfoCollectionEl = doc.getElementsByTagNameNS('http://www.esri.com/wms', 'FeatureInfoCollection');

  var _loop = function _loop(k) {
    var layerName = featureInfoCollectionEl[k].getAttribute('layername');
    var featureInfosEl = featureInfoCollectionEl[k].getElementsByTagNameNS('http://www.esri.com/wms', 'FeatureInfo');

    var _loop2 = function _loop2(i) {
      var feature = {};
      var properties = {};
      var fieldsEl = featureInfosEl[i].getElementsByTagNameNS('http://www.esri.com/wms', 'Field');

      for (var j = 0; j < fieldsEl.length; ++j) {
        var fieldName = fieldsEl[j].getElementsByTagNameNS('http://www.esri.com/wms', 'FieldName')[0].childNodes[0].nodeValue;
        var fieldValue = fieldsEl[j].getElementsByTagNameNS('http://www.esri.com/wms', 'FieldValue')[0].childNodes[0].nodeValue;
        properties[fieldName] = fieldValue;
      }

      feature['getProperties'] = function () {
        return properties;
      };

      feature['getId'] = function () {
        return "".concat(layerName, ".").concat(i);
      };

      features.push(feature);
    };

    for (var i = 0; i < featureInfosEl.length; ++i) {
      _loop2(i);
    }

    return {
      v: features
    };
  };

  for (var k = 0; k < featureInfoCollectionEl.length; ++k) {
    var _ret = _loop(k);

    if (_typeof(_ret) === "object") return _ret.v;
  }
};
/**
 * Method to parse the features from GetFeatureInfo response having the 
 * info_format = 'application/vnd.esri.wms_featureinfo_xml'
 */


exports.parseEsriWmsRawXml = parseEsriWmsRawXml;

var parseEsriWmsFeatureInfoXml = function parseEsriWmsFeatureInfoXml(source) {
  var doc = null;

  if (typeof source === 'string') {
    var parser = new DOMParser();
    doc = parser.parseFromString(source, "application/xml");
  } else {
    doc = source;
  }

  var features = [];
  var featureInfoCollectionEl = doc.getElementsByTagNameNS('http://www.esri.com/wms', 'FeatureInfoCollection');

  var _loop3 = function _loop3(k) {
    var layerName = featureInfoCollectionEl[k].getAttribute('layername');
    var featureInfosEl = featureInfoCollectionEl[k].getElementsByTagNameNS('http://www.esri.com/wms', 'FeatureInfo');

    var _loop4 = function _loop4(i) {
      var feature = {};
      var properties = {};
      var fieldsEl = featureInfosEl[i].getElementsByTagNameNS('http://www.esri.com/wms', "Field");

      for (var j = 0; j < fieldsEl.length; ++j) {
        var fieldName = fieldsEl[j].getElementsByTagNameNS('http://www.esri.com/wms', 'FieldName')[0].innerHTML;
        var fieldValue = fieldsEl[j].getElementsByTagNameNS('http://www.esri.com/wms', 'FieldValue')[0].innerHTML;
        properties[fieldName] = fieldValue;
      }

      feature['getProperties'] = function () {
        return properties;
      };

      feature['getId'] = function () {
        return "".concat(layerName, ".").concat(i);
      };

      features.push(feature);
    };

    for (var i = 0; i < featureInfosEl.length; ++i) {
      _loop4(i);
    }

    return {
      v: features
    };
  };

  for (var k = 0; k < featureInfoCollectionEl.length; ++k) {
    var _ret2 = _loop3(k);

    if (_typeof(_ret2) === "object") return _ret2.v;
  }
};

exports.parseEsriWmsFeatureInfoXml = parseEsriWmsFeatureInfoXml;

var parseFeatureInfo = function parseFeatureInfo(source, infoFormat) {
  switch (infoFormat) {
    case 'application/json':
      return parseFeatureInfoJSON(source);

    case 'application/vnd.esri.wms_featureinfo_xml':
      return parseEsriWmsFeatureInfoXml(source);

    case 'application/vnd.esri.wms_raw_xml':
      return parseEsriWmsRawXml(source);

    case 'text/xml':
      return parseFeatureInfoTextXml(source);

    default:
      return parseFeatureInfoJSON(source);
  }
};

exports.parseFeatureInfo = parseFeatureInfo;